<template>
  <div class="zoom-controls smooth-shadow">
    <div class="tooltip-icon" @click="zoomIn()">
      <i class="material-icons icon-button md-18">add</i>
      <span class="icon-tooltip">Zoom In</span>
    </div>
    <div class="tooltip-icon" @click="zoomOut()">
      <i class="material-icons icon-button md-18">remove</i>
      <span class="icon-tooltip">Zoom Out</span>
    </div>
    <div class="line"></div>
    <div class="tooltip-icon" @click="toggleTilt()">
      <i :class="['material-icons', 'icon-button', 'md-18', { tilt: isTilted }]"
        >navigation</i
      >
      <span class="icon-tooltip">Tilt Map</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("Map", ["isTilted"]),
  },
  methods: {
    ...mapActions("Map", ["zoomIn", "zoomOut", "toggleTilt"]),
  },
};
</script>

<style lang="scss" scoped>
.zoom-controls {
  position: absolute;
  z-index: 99;
  top: 160px;
  left: 12px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  background-color: var(--color-secondary);
  border: 1px solid var(--border-color);
  padding: 5px 0;
  transition: 0.3s all ease-in-out;

  .line {
    border-top: 1px solid var(--color-primary-light);
    margin: 5px;
  }

  i {
    transition: 0.3s all ease-in-out;
    &.tilt {
      transform: rotate(45deg);
    }
  }

  .tooltip-icon {
    .icon-tooltip {
      position: absolute;
      width: auto;
      min-width: 100px;
      text-align: center;
      background: var(--color-secondary);
      white-space: no-wrap;
      margin-left: 15px;
      padding: 10px 10px;
      border-radius: 5px;
      transform: translate(-50px, 0);
      opacity: 0;
      transition: 0.3s all ease-in-out;
      pointer-events: none;

      &:after {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-right-color: var(--color-secondary);
        border-left: 0;
        margin-top: -10px;
        margin-left: -10px;
      }
    }

    &:hover {
      .icon-tooltip {
        display: inline;
        opacity: 1;
        transform: translate(0px, 0);
      }
    }
  }
}
</style>
